// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e4270e41","833":"d826dec6"}[chunkId] + ".chunk.js";
};